import { UserRole } from '@model/enum/user-role.enum';
import { Profile } from '@model/profile';

export function validateUserRoles(profile: Nullable<Profile>, roles: UserRole[]): boolean {
  return profile?.ROLES.some(({ authority }) => roles.includes(authority)) || false;
}
